import { render } from "./SupportIcon.vue?vue&type=template&id=694008c0"
import script from "./SupportIcon.vue?vue&type=script&lang=js"
export * from "./SupportIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__